export default __webpack_public_path__ + "static/media/rr.777f059b.jpeg";